import MapSettingModal from "components/modalComponents/MapSettingModal";
import DeviceDetector from "device-detector-js";
import md5 from "md5";
import ChooseLogTypePc from "pagesPc/utils/modalSettingsPc/ChooseLogTypePc";
import ChoosePaymentPc from "pagesPc/utils/modalSettingsPc/ChoosePaymentPc";
import SessionModalPc from "pagesPc/utils/modalSettingsPc/SessionModalPc";
import { useState, useEffect } from "react";
import {
  useFcmDeviceDeleteMutation, useLazyProfileUpdateQuery, useProfileQuery,
  useTelegramBotMutation,
} from "redux/RTQ/IlenkradApi";
import ForceUpdateModal from "utils/other/ForceUpdateModal";
import { notificationGranted } from "utils/other/permission";
import {ToastDanger, ToastSuccess} from "utils/toast/Toast";
import {SettingItem} from 'types/settings/settingItem';

const SettingsPc = ({ getTheme, closeDrawer, checkFcm }: any) => {

  const [mutateDeleteFcm, { data: dataDelete, isSuccess: isSuccessDelete }] =
    useFcmDeviceDeleteMutation();
  const { refetch:profileRefetch } = useProfileQuery();
  const [
    mutateUpdateProfile
    ,
  ] = useLazyProfileUpdateQuery();

  const [telegramBotStatus,setTelegramBotStatus]=useState<boolean>(false);
  const [twoStepVerification,setTwoStepVerification]=useState<boolean>(false);

  useEffect(() => {
    profileRefetch().then(({data,isSuccess:isSuccessProfile})=>{
      const userProfileData = data as any;
      if (!isSuccessProfile){
        ToastDanger("اطلاعات پروفایل شما به درستی دریافت نشد")
      }
      setTwoStepVerification(!!userProfileData?.user?.mfa_enabled);
      setTelegramBotStatus(!!userProfileData?.user?.telegram_bot);
    })
  }, []);


  const [item, setItem] = useState<any>([
    {
      title: "نمایش مارکرهای سابقه موقعیت",
      border: true,
      active: localStorage.getItem("showHistoryMarker")
        ? localStorage.getItem("showHistoryMarker") === "true"
        : true,
      switch: true,
      key: 1,
      icon: "icon3-location_on",
    },
    {
      title: "نمایش مسیر آنلاین",
      border: true,
      active: localStorage.getItem("showOnlineMarker")
        ? localStorage.getItem("showOnlineMarker") === "true"
        : true,
      switch: true,
      key: 2,
      icon: "icon3-route",
    },
    {
      title: "دریافت اعلان ها",
      border: true,
      active: localStorage.getItem("getAlerts")
        ? localStorage.getItem("getAlerts") === "true"
        : true,
      switch: true,
      key: 3,
      icon: "icon3-notifications_active",
    },
    {
      title: "وضعیت ربات تلگرام",
      border: true,
      active: telegramBotStatus,
      switch: true,
      telegram: "https://telegram.me/lenkrad_bot?start=login?start=login",
      key: 33,
      icon: "icon3-notifications_active",
    },
    {
      title: "فعال سازی نوع ورود",
      border: false,
      active: false,
      key: 4,
      icon: "icon3-input",
      url: "showModalChooseLogType",
    },
    {
      title: "درگاه ارسال دستورات",
      border: false,
      active: false,
      key: 6,
      icon: "icon3-code",
      url: "showModalChoosePayment",
    },
    {
      title: "نشست های فعال",
      border: false,
      active: false,
      key: 7,
      icon: "icon3-emoji_objects",
      url: "showModalSession",
    },
    {
      title: "بازگشت به تنظیمات کارخانه",
      border: false,
      active: false,
      key: 8,
      forceUpdate: true,
      icon: "icon7-auto-apn",
      url: "showModalForceUpdate",
    },
    {
      title: "تنظیمات نقشه",
      border: false,
      active: false,
      key: 7,
      icon: "icon3-emoji_objects",
      url: "showModalMapSetting",
    },
    {
      title: " ورود دو مرحله ای",
      border: true,
      active: twoStepVerification,
      switch: true,
      key: 8,
      icon: "icon3-fingerprint",
    },
    {
      title: "قوانین",
      border: false,
      active: false,
      key: 9,
      icon: "icon3-privacy_tip",
      rules:true
    },
  ]);
  useEffect(() => {
    setItem((items:SettingItem[]) => items.map((item: SettingItem) => {
      if(item.key !== 33) return item;
      return {
        ...item,
        active: telegramBotStatus
      }
    }))
  }, [telegramBotStatus]);

  useEffect(() => {
    setItem((items:SettingItem[]) => items.map((item: SettingItem) => {
      if(item.key !== 8) return item;
      return {
        ...item,
        active: twoStepVerification
      }
    }))
  }, [twoStepVerification]);

  const [mutateTelegram] = useTelegramBotMutation();
  const submitTelegramBot = (item: any) => {
    const obj = {
      telegram_bot: item,
    };
    mutateTelegram(obj).then((data)=>{
      const mutateTelegramResponse = data as any;
      if(mutateTelegramResponse?.data?.success!==true){
        ToastDanger('وضعیت ربات تلگرام به درستی تغییر نیافت');
      }
      setTelegramBotStatus(item);
    });
  };

  const submitTwoStepVerification = (mfa:boolean) =>{
    profileRefetch().then(({isSuccess:isProfileSuccess,data})=>{
      const userProfileData = data as any;
      if (!isProfileSuccess){
        ToastDanger("اطلاعات پروفایل شما به درستی دریافت نشد");
      }
      const profile = {name:userProfileData?.user?.name,phone_number:userProfileData?.user.phone_number,mfa_enabled:mfa};
      mutateUpdateProfile(profile).then(({isSuccess:isSuccessUpdateProfile})=>{
        if(!isSuccessUpdateProfile){
          mfa?ToastDanger("ورود دو مرحله ای برای شما فعال نشد"):ToastDanger("ورود دو مرحله ای برای شما غیرفعال نشد");
        }
        setTwoStepVerification(mfa);
        mfa?ToastSuccess("ورود دو مرحله ای فعال شد"):ToastSuccess("ورود دو مرحله ای غیرفعال شد");
      })
    });
  }
  const changeCheckBox = (ind: any) => {
    let check = true;
    switch (ind) {
      case 0:
        localStorage.setItem(
          "showHistoryMarker",
          item[ind].active ? "false" : "true"
        );
        break;

      case 1:
        localStorage.setItem(
          "showOnlineMarker",
          item[ind].active ? "false" : "true"
        );
        break;

      case 2:
        const detector = new DeviceDetector();
        const os: any = detector.parse(window.navigator.userAgent).os;
        if (os.name === "Android") {
          if (!notificationGranted()) {
            ToastDanger("لطفا دسترسی به ناتیفیکیشن را در سیستم خود فعال کنید.");
            check = false;
          } else {
            localStorage.setItem(
              "getAlerts",
              item[ind].active ? "false" : "true"
            );
            const fcmToken = localStorage.getItem("fcmToken");
            if (item[ind].active && fcmToken) {
              const fcmTokenObj = JSON.parse(fcmToken);
              mutateDeleteFcm({
                body: { token: fcmTokenObj?.token, platform: "web" },
                token_md5: md5(fcmTokenObj.tokenMD5),
              });
            } else {
              checkFcm();
            }
          }
        } else {
          localStorage.setItem(
            "getAlerts",
            item[ind].active ? "false" : "true"
          );
          const fcmToken = localStorage.getItem("fcmToken");
          if (item[ind].active && fcmToken) {
            const fcmTokenObj = JSON.parse(fcmToken);
            mutateDeleteFcm({
              body: { token: fcmTokenObj?.token, platform: "web" },
              token_md5: md5(fcmTokenObj.tokenMD5),
            });
          } else {
            checkFcm();
          }
        }

        break;
      case 3:
        submitTelegramBot(!telegramBotStatus);
        break;
      case 9:
        submitTwoStepVerification(!twoStepVerification);
        break;
      default:
        break;
    }
    if (check) {
      let newState = [...item];
      newState[ind].active = !newState[ind].active;
      setItem(newState);
    }
  };
  useEffect(() => {
    if (isSuccessDelete) {
      localStorage.removeItem("fcmToken");
    }
  }, [isSuccessDelete, dataDelete]);
  const [openModalChosseMap, setopenModalChosseMap] = useState<boolean>(false);
  const showModalChosseMap = () => {
    setopenModalChosseMap(!openModalChosseMap);
  };
  const [openModalChoosePayment, setopenModalChoosePayment] =
    useState<boolean>(false);
  const showModalChoosePayment = () => {
    setopenModalChoosePayment(!openModalChoosePayment);
  };
  const [openModalSession, setOpenModalSession] = useState<boolean>(false);
  const showModalSession = () => {
    setOpenModalSession(!openModalSession);
  };
  const [openModalMapSetting, setOpenModalMapSetting] = useState<boolean>(false);
  const showModalMapSetting = () => {
    setOpenModalMapSetting(!openModalMapSetting);
  };
  const [openModalChooseCountry, setopenModalChooseCountry] =
    useState<boolean>(false);
  const showModalChooseCountry = () => {
    setopenModalChooseCountry(!openModalChooseCountry);
  };
  const [openModalChooseLang, setopenModalChooseLang] =
    useState<boolean>(false);
  const showModalChooseLang = () => {
    setopenModalChooseLang(!openModalChooseLang);
  };
  const [openModalChooseLogType, setopenModalChooseLogType] =
    useState<boolean>(false);
  const showModalChooseLogType = () => {
    setopenModalChooseLogType(!openModalChooseLogType);
  };
  const [openModalChangePass, setopenModalChangePass] =
    useState<boolean>(false);
  const showModalChangePass = () => {
    setopenModalChangePass(!openModalChangePass);
  };
  const [openModalForceUpdate, setopenModalForceUpdate] =
    useState<boolean>(false);
  const showModalForceUpdate = () => {
    setopenModalForceUpdate(!openModalForceUpdate);
  };
  const openRulesPage = () => {
    window.open('https://lenkrad.ir/t-c.html ','_blank');
  }
  const navigateToPage = (url: string,index:number) => {
    if (url === "showModalChooseMap") {
      showModalChosseMap();
    } else if (url === "showModalChoosePayment") {
      showModalChoosePayment();
    } else if (url === "showModalChooseCountry") {
      showModalChooseCountry();
    } else if (url === "showModalChooseLang") {
      showModalChooseLang();
    } else if (url === "showModalChooseLogType") {
      showModalChooseLogType();
    } else if (url === "showModalChangePass") {
      showModalChangePass();
    } else if (url === "showModalSession") {
      showModalSession();
    } else if (url === "showModalForceUpdate") {
      showModalForceUpdate();
    } else if (url === "showModalMapSetting") {
      showModalMapSetting();
    }
  };
  const navigateToTelegram = (url: string) => {
    window.open(`${url}`, "_blank");
  };

  return (
    <>
      <ChoosePaymentPc
        onClose={showModalChoosePayment}
        open={openModalChoosePayment}
      />
      <SessionModalPc onClose={showModalSession} open={openModalSession} />
      <MapSettingModal onClose={showModalMapSetting} open={openModalMapSetting} />


      <ChooseLogTypePc
        onClose={showModalChooseLogType}
        open={openModalChooseLogType}
      />
      {/* <ChooseMapPc onClose={showModalChosseMap} open={openModalChosseMap} /> */}
      {/* <ChooseCountryPc
        onClose={showModalChooseCountry}
        open={openModalChooseCountry}
      /> */}
      {/* <ChooseLangPc onClose={showModalChooseLang} open={openModalChooseLang} /> */}
      {/* <ChooseLogTypePc
        onClose={showModalChooseLogType}
        open={openModalChooseLogType}
      /> */}
      {/* <ChangePasswordPc
        onClose={showModalChangePass}
        open={openModalChangePass}
      /> */}
      <ForceUpdateModal
        onClose={showModalForceUpdate}
        open={openModalForceUpdate}
      />
      <div className="rowheaderModalSettingMap">
        <div onClick={closeDrawer} className="icon3-close pointer" />
        <div className="titleheaderModalPc">تنظیمات</div>
      </div>

      <div className="contentListTracker scrollbar-div">
        {item.map((it: any, index: number) => (
          <div
            key={index}
            className={
              getTheme === "dark"
                ? "ItemListTrackerContainer"
                : "ItemListTrackerContainerLight"
            }
          >
            <div
              className={
                it.border && it.active
                  ? "itemSettingsActive"
                  : it.border && !it.active
                    ? "itemSettings"
                    : !it.border
                      ? "itemSettingsNoneBorder"
                      : "itemSettingsNoneBorder"
              }
            >
              <div className="rowItemSetting">
                <div className={it.icon} />
                <div className="titleSettingPage">{it.title}</div>
              </div>
              <div className="rowBtnItemSetting">
                {it.telegram ? (
                  <div className="telegramBotContainer">
                    <div className="paddingLeftSwitch">
                      <span className="statusSwitchTitle">
                        {it.active ? "فعال" : "غیر فعال"}
                      </span>
                      <label className="switch">
                        <input
                          type="checkbox"
                          onChange={() => changeCheckBox(index)}
                          checked={it.active}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                    <div
                      style={{ pointerEvents: it.active ? "initial" : "none" }}
                      onClick={() => navigateToTelegram(it.telegram)}
                      className="btnActiveSetting"
                    >
                      ربات تلگرام
                    </div>
                  </div>
                ) : it.switch ? (
                  <div className="paddingLeftSwitch">
                    <span className="statusSwitchTitle">
                      {it.active === true ? "فعال" : "غیر فعال"}
                    </span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        onChange={() => changeCheckBox(index)}
                        checked={it.active}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                ) : it.forceUpdate ? (
                  <div
                    onClick={() => navigateToPage(it.url, index)}
                    className="btnActiveSetting pointer"
                  >
                    بازگشت
                  </div>
                ) :it.rules ? (
                  <div
                    onClick={()=>openRulesPage()}
                    className="btnActiveSetting pointer">
                    مشاهده
                  </div>
                ) : (
                  <div
                    onClick={() => navigateToPage(it.url, index)}
                    className="btnActiveSetting pointer"
                  >
                    انتخاب کردن
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
export default SettingsPc;
